import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';

import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { BusinessProductPaymentInvoiceDetailPage } from '../../pages/business-product-payment-invoice-detail/business-product-payment-invoice-detail';

@Component({
  selector: 'page-business-product-payment-invoice-list',
  templateUrl: 'business-product-payment-invoice-list.html',
})
export class BusinessProductPaymentInvoiceListPage {
	isRefreshing: boolean = false;
	isLoading: boolean = false;
	isFetchingMore: boolean = false;
	
	loadingMsg: any = "Loading...";

	lastRequestReturnedValues: boolean = false;

	invoices: any = [];
	hasData: boolean = true;

	term: any = "";

	params: any = {
	    page: 1,
	    size: 25,
	    term: '',
	    cb: null
	  }


	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler,
		public businessProductPaymentManagerHandler: BusinessProductPaymentManagerHandler,
		public navCtrl: NavController, 
		public toastCtrl: ToastController,
		public navParams: NavParams) {

		this.getOrders(null, true)
	}

	resetInvoices() {
	    this.invoices = [];
	  }

	getOrders(ev: any, isPageLoad) {
	    // Reset items back to all of the items
	    this.resetInvoices();
	    // set val to the value of the searchbar
	    let val = isPageLoad ? '' : ev.target.value;
	    let params = {
	        page: this.params.page,
	        size: this.params.size,
	        term: '',

	        cb: (invoices)=>{
	          this.isLoading = false;

	          this.lastRequestReturnedValues = (invoices.length==0) ? false : true;

	          this.hasData = (invoices.length == 0 && this.params.page == 1) ? false : true;

	          if(this.params.page == 1){

	            this.invoices = invoices;  
	          }else{
	            for (var i = invoices.length - 1; i >= 0; i--) {
	              this.invoices.push(invoices[i]);
	            }          
	          }
	        }
	      }

	    // if the value is an empty string don't filter the items
	    if (val || (val.trim() == '' && isPageLoad)) {
	      params.term = val
	    }

	    this.businessProductPaymentManagerHandler.searchOrders(params);
	  }

	viewDetail(invoice){
		this.navCtrl.push(BusinessProductPaymentInvoiceDetailPage, {invoice: invoice});		
	}  


}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-invoice-list/business-product-payment-invoice-list.ts